import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import { categoryPropTypes } from '../SubStage/SubStage';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import InfoCircle from '../../../images/info-circle.svg';
import Popover from 'react-bootstrap/Popover';
import * as DOMPurify from 'dompurify';

const propTypes = {
  isChecked: PropTypes.func,
  handleClick: PropTypes.func,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  units: PropTypes.string.isRequired,
  ...categoryPropTypes,
};

export default function Category(props: InferProps<typeof propTypes>): JSX.Element {
  const {
    name,
    feeValue,
    feeQuantity,
    maxQuantity,
    placeholder,
    units,
    helpText,
    estimateRequired,
    error,
    isDisabled,
    isChecked,
    handleClick,
    handleChange
  } = props;

  function inputField() {
    if (maxQuantity !== 1 && !estimateRequired) {
      return (
        <>
          <Form.Control
            isInvalid={!!error?.isError}
            className="category-input-quantity"
            placeholder={placeholder}
            type="number"
            disabled={isDisabled ?? false}
            min={0}
            step={1}
            value={feeQuantity ?? ""}
            onChange={e => handleChange(e.target.value)}
          />
        </>
      )
    }
    return null;
  }

  function helpPrompt() {
    let sanitizedHelpText = DOMPurify.sanitize(helpText, {ADD_ATTR: ['target']});
    return helpText
      ? <OverlayTrigger
        trigger={['hover', 'focus']}
        placement='top'
        delay={{ show: 250, hide: 1500 }}
        container={document.getElementById('AppRoot').shadowRoot}
        overlay={
          <Popover id={`popover-${name}`} >
          <Popover.Header as="h3">{name}</Popover.Header>
          <Popover.Body>
            <div dangerouslySetInnerHTML={{ __html: sanitizedHelpText }} />
          </Popover.Body>
        </Popover>
        }
      >
        <img src={InfoCircle} alt="Help icon" className='help-icon' tabIndex={0} />
      </OverlayTrigger>
      : null

  }

  return (
    <div className="category">
      <Row>
        <Col md={{ span: 4, offset: 4 }} className="category-name">
          <p>
            {name}
          </p>
          {helpPrompt()}
        </Col>
        <Col md={4} className="category-input">
          <InputGroup size="lg" hasValidation={true}>
            {inputField()}
            <InputGroup.Text className="category-label">
              {estimateRequired ? 'Estimate required' : `$${feeValue}`}
            </InputGroup.Text>
            <InputGroup.Checkbox
              type="checkbox"
              id={name}
              name={name}
              disabled={isDisabled}
              label={`$${feeValue}`}
              value=""
              checked={isChecked()}
              onChange={() => handleClick()}
            />
            <Form.Control.Feedback type="invalid">
              {
                error?.isError ? error?.message : null
              }
            </Form.Control.Feedback>
          </InputGroup>
          <Form.Text id={`max-quantity-text-${name}`} muted>
            {/* {maxQuantity > 1 ? `Max quantity: ${maxQuantity} x ${units}` : ""} */}
            {maxQuantity > 1 
            ? (units ? `Max quantity: ${maxQuantity} x ${units}` : `Max quantity: ${maxQuantity}`)
            : ""}
          </Form.Text>
        </Col>
      </Row>
    </div>
  );
}
